import { ReactNode } from 'react';
import { FormFinancialAPIHelpers, FormFinancialContext } from './form-financial-context';

export const FormFinancialContextProvider = (props: FormFinancialAPIHelpers & { children: ReactNode }) => {
	const { children, ...rest } = props;
	return <FormFinancialContext.Provider value={{ ...rest }}>{children}</FormFinancialContext.Provider>;
};
